import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {BettingAdBoostApiModel} from "./betting-ad.boost.api-model";
import {BettingAdBoostOddDomainModel} from "./odds/betting-ad.boost-odd.domain-model";

export class BettingAdBoostDomainModel extends BaseDomainModel {
  apiModel: BettingAdBoostApiModel;

  constructor(apiModel: BettingAdBoostApiModel, gameId) {
    super(apiModel);

    this.gameId = gameId;
    this.bookmakerId = apiModel.bmid;
    this._link = apiModel.link;
    this.markets = apiModel.markets;
    this.odds = apiModel.odds ? new BettingAdBoostOddDomainModel(apiModel.odds) : null;
  }

  get link(): String {
    const links = {
      14: "https://www.bet365.com/olp/open-account?affiliate=365_03765349",
      47: "https://gml-grp.com/C.ashx?btag=a_12523b_1246c_&affid=3532&siteid=12523&adid=1246&c=Context-BWP_Platform_OS-Web_$GUID",
      139: "https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2151249&tdpeh=$NAMECONTEXT__$GUID&btag=301645",
      156: "https://rt.novibet.partners/o/sLhGsU?lpage=jcBppl&site_id=1009255&s1=$NAMECONTEXT__$GUID",
      161: "https://wlsuperbet.adsrv.eacdn.com/C.ashx?btag=a_4872b_431c_&affid=640&siteid=4872&adid=431&c=$NAMECONTEXT__$GUID",

    }

    const link = links[this.bookmakerId] || this._link;

    return link;
  }
}